var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "q-display-1 q-mb-md" }, [
        _c("span", { staticClass: "q-headline text-weight-light" }, [
          _vm._v(_vm._s(_vm.$t("photo_upload_history")))
        ])
      ]),
      _c("q-table", {
        attrs: {
          data: _vm.historys,
          columns: _vm.columns_history,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    icon: "far fa-search",
                    placeholder: _vm.$t("search"),
                    debounce: 500
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-positive capitalize text-weight-bold q-mr-md"
                  },
                  [
                    _c("q-icon", { attrs: { name: "fal fa-check" } }),
                    _vm._v(
                      "\n                 " +
                        _vm._s(_vm.calculatePercentage(_vm.qty_file_audited)) +
                        "% " +
                        _vm._s(_vm.$t("audited")) +
                        "\n             "
                    )
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-negative capitalize text-weight-bold q-mr-md"
                  },
                  [
                    _c("q-icon", { attrs: { name: "fal fa-ban" } }),
                    _vm._v(
                      "\n                 " +
                        _vm._s(_vm.calculatePercentage(_vm.qty_file_reproved)) +
                        "% " +
                        _vm._s(_vm.$t("reproved")) +
                        "\n             "
                    )
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-warning capitalize text-weight-bold q-mr-md"
                  },
                  [
                    _c("q-icon", {
                      attrs: { name: "fal fa-exclamation-triangle" }
                    }),
                    _vm._v(
                      "\n                 " +
                        _vm._s(
                          _vm.calculatePercentage(_vm.qty_file_unaudited)
                        ) +
                        "% " +
                        _vm._s(_vm.$t("unaudited")) +
                        "\n             "
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n             " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n             "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c("q-td", { key: "id", attrs: { props: props } }, [
                    _vm._v(
                      "\n                 " +
                        _vm._s(props.row.id) +
                        "\n             "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "reward_upload_file_type", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                 " +
                          _vm._s(props.row.reward_upload_file_type) +
                          "\n             "
                      )
                    ]
                  ),
                  _c("q-td", { key: "company", attrs: { props: props } }, [
                    _vm._v(
                      "\n                 " +
                        _vm._s(props.row.company) +
                        "\n             "
                    )
                  ]),
                  _c("q-td", { key: "branch", attrs: { props: props } }, [
                    _vm._v(
                      "\n                 " +
                        _vm._s(props.row.branch) +
                        "\n             "
                    )
                  ]),
                  _c("q-td", { key: "created_date", attrs: { props: props } }, [
                    _vm._v(
                      "\n                 " +
                        _vm._s(props.row.created_date) +
                        "\n             "
                    )
                  ]),
                  _c("q-td", { key: "total_points", attrs: { props: props } }, [
                    _vm._v(
                      "\n                 " +
                        _vm._s(
                          props.row.total_points
                            ? Math.round(props.row.total_points * 100) / 100
                            : 0
                        ) +
                        "\n             "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                     " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                 "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "far fa-hourglass"
                        },
                        on: {
                          click: function($event) {
                            return _vm.openModalHistory(props.row)
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "far fa-list-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.openModal(props.row)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "90vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_photo,
            callback: function($$v) {
              _vm.show_photo = $$v
            },
            expression: "show_photo"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_photo = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                     " +
                        _vm._s(_vm.photo.reward_upload_file_type) +
                        "\n                 "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: " q-mb-md row justify-between items-center" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "q-display-1 q-headline text-weight-light"
                      },
                      [_vm._v(_vm._s(_vm.$t("photo_information")))]
                    )
                  ]
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("div", { staticClass: "row gutter-xs" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("company"),
                            disable: ""
                          },
                          model: {
                            value: _vm.photo.company,
                            callback: function($$v) {
                              _vm.$set(_vm.photo, "company", $$v)
                            },
                            expression: "photo.company"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("branch"),
                            disable: ""
                          },
                          model: {
                            value: _vm.photo.branch,
                            callback: function($$v) {
                              _vm.$set(_vm.photo, "branch", $$v)
                            },
                            expression: "photo.branch"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("photo_type"),
                            disable: ""
                          },
                          model: {
                            value: _vm.photo.reward_upload_file_type,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.photo,
                                "reward_upload_file_type",
                                $$v
                              )
                            },
                            expression: "photo.reward_upload_file_type"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("created_date"),
                            disable: ""
                          },
                          model: {
                            value: _vm.photo.created_date,
                            callback: function($$v) {
                              _vm.$set(_vm.photo, "created_date", $$v)
                            },
                            expression: "photo.created_date"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("total_points"),
                            disable: ""
                          },
                          model: {
                            value: _vm.photo.total_points,
                            callback: function($$v) {
                              _vm.$set(_vm.photo, "total_points", $$v)
                            },
                            expression: "photo.total_points"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            label: _vm.$t("images"),
                            icon: "fal fa-eye"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openImage()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _vm.showButtonsEdit
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: "negative",
                                label: _vm.$t("reprove"),
                                icon: "far fa-times"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show_confirm_reprove_photo = true
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showButtonsEdit
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: "positive",
                                label: _vm.$t("approve"),
                                icon: "far fa-check-double"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setStatus(4)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_photo = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            maximized: "",
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_images,
            callback: function($$v) {
              _vm.show_images = $$v
            },
            expression: "show_images"
          }
        },
        [
          _c("q-modal-layout", [
            _c(
              "div",
              { staticClass: "layout-padding" },
              [
                _c(
                  "q-carousel",
                  {
                    ref: "carousel",
                    staticClass: "full-height",
                    attrs: { arrows: "", color: "white" }
                  },
                  [
                    _c(
                      "q-carousel-slide",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "v-zoomer",
                          {
                            style: _vm.classZoomer,
                            attrs: { pivot: "cursor", limitTranslation: false }
                          },
                          [
                            _c("img", {
                              staticStyle: { "max-height": "80vh" },
                              style: _vm.classRotate,
                              attrs: { src: _vm.photo.upload_file }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-carousel-control",
                      {
                        attrs: {
                          slot: "control-button",
                          position: "top-right"
                        },
                        slot: "control-button"
                      },
                      [
                        _c("q-btn", {
                          attrs: { round: "", dense: "", icon: "far fa-times" },
                          on: {
                            click: function($event) {
                              return _vm.fullscreen()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-carousel-control",
                      {
                        attrs: {
                          slot: "control-nav",
                          position: "bottom-right"
                        },
                        slot: "control-nav"
                      },
                      [
                        _c("q-btn", {
                          attrs: { round: "", dense: "", icon: "far fa-undo" },
                          on: {
                            click: function($event) {
                              return _vm.rotate("-")
                            }
                          }
                        }),
                        _c("q-btn", {
                          attrs: {
                            round: "",
                            dense: "",
                            icon: "far fa-redo-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.rotate("+")
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_confirm_remove_photo = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removePhoto()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_confirm_remove_photo,
            callback: function($$v) {
              _vm.show_confirm_remove_photo = $$v
            },
            expression: "show_confirm_remove_photo"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("delete_photo")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "do_you_really_want_to_delete_the_photo_this_action_cannot_be_undone"
                )
              )
            )
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_confirm_reprove_photo = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "negative",
                      label: _vm.$t("reprove"),
                      disable: !_vm.justification
                    },
                    on: {
                      click: function($event) {
                        return _vm.setStatus(2)
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_confirm_reprove_photo,
            callback: function($$v) {
              _vm.show_confirm_reprove_photo = $$v
            },
            expression: "show_confirm_reprove_photo"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("reprove_photo")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t("inform_the_reason_for_the_disapproval_of_the_photo")
              )
            )
          ]),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", { staticClass: "row q-gutter-sm" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.reward_audit_file_justifications,
                      "float-label": _vm.$t("justification")
                    },
                    model: {
                      value: _vm.justification,
                      callback: function($$v) {
                        _vm.justification = $$v
                      },
                      expression: "justification"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("q-input", {
                    attrs: { "float-label": _vm.$t("observation") },
                    model: {
                      value: _vm.observation,
                      callback: function($$v) {
                        _vm.observation = $$v
                      },
                      expression: "observation"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "90vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_audit_history,
            callback: function($$v) {
              _vm.show_audit_history = $$v
            },
            expression: "show_audit_history"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_audit_history = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                     " +
                        _vm._s(_vm.$t("audit_history")) +
                        "\n                 "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.audit_history,
                      columns: _vm.columns_audit_history,
                      pagination: _vm.server_pagination_audit_history,
                      filter: _vm.filter,
                      "row-key": "audited_date",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [0],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination_audit_history = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                         " +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n                         "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                {
                                  key: "from_status",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _c(
                                    "q-chip",
                                    {
                                      attrs: {
                                        small: "",
                                        icon: _vm.getIconStatus(
                                          props.row.from_status
                                        ),
                                        color: _vm.getColorStatus(
                                          props.row.from_status
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                 " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.getStatus(
                                                props.row.from_status
                                              )
                                            )
                                          ) +
                                          "\n                             "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "to_status", attrs: { props: props } },
                                [
                                  _c(
                                    "q-chip",
                                    {
                                      attrs: {
                                        small: "",
                                        icon: _vm.getIconStatus(
                                          props.row.to_status
                                        ),
                                        color: _vm.getColorStatus(
                                          props.row.to_status
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                 " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.getStatus(props.row.to_status)
                                            )
                                          ) +
                                          "\n                             "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "audited_date",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                             " +
                                      _vm._s(
                                        _vm.fDateTime(props.row.audited_date)
                                      ) +
                                      "\n                         "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "user_audited",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                             " +
                                      _vm._s(props.row.user_audited) +
                                      "\n                         "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "justification",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                             " +
                                      _vm._s(props.row.justification) +
                                      "\n                         "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "observation", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                             " +
                                      _vm._s(props.row.observation) +
                                      "\n                         "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }